
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '../../models/User';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { TranslateModule } from '@ngx-translate/core';
import { PremiumOfferService } from '../../services/premium-offer.service';
import { StorageService } from '../../services/storage.service';

@Component({
    selector: 'app-onboarding1',
    standalone: true,
    imports: [TranslateModule],
    templateUrl: './onboarding1.component.html',
    styleUrl: './onboarding1.component.scss',
})
export class Onboarding1Component {
    user?: User;

    constructor(
        private router: Router,
        private authService: AuthService,
        private premiumOfferService: PremiumOfferService,
        private storageService: StorageService,
    ) {}

    async ngOnInit() {
        this.user = await firstValueFrom(
            this.authService.getUserInfoOrRefreshIfNeeded()
        );
    }

    next() {
        this.router.navigate(['/onboarding/2']);
    }

    shouldDisplayFourthStep(): boolean {
        return !this.storageService.isAnonymous() && this.premiumOfferService.canSeePremiumOffers(this.user);
    }
}
